export function getRegistrationPaymentEnabledCityIds(): number[] {
  const raw = useRuntimeConfig().public.registrationPaymentEnabledCities
  return String(raw ?? '').split(',').map(s => Number(s.trim())).filter(Boolean)
}

export function isRegistrationAndPaymentEnabled(cityLocationId?: number): boolean {
  if (!cityLocationId) {
    return false
  }
  return getRegistrationPaymentEnabledCityIds().includes(cityLocationId)
}
